import { formatSummaryForDisplay } from "../../utils/callDisplay";

function humanizeValue(value) {
  const text = String(value || "").trim();

  if (!text) {
    return "";
  }

  if (/^[a-z0-9_\-\s]+$/i.test(text) && text === text.toLowerCase()) {
    return text
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, (character) => character.toUpperCase());
  }

  return text;
}

function SummaryField({ label, value }) {
  if (!value) {
    return null;
  }

  return (
    <div className="space-y-1">
      <div className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
        {label}
      </div>
      <div className="text-gray-800 text-[15px] leading-relaxed break-words whitespace-pre-wrap">
        {value}
      </div>
    </div>
  );
}

function SummaryList({ label, items }) {
  if (!Array.isArray(items) || !items.length) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
        {label}
      </div>
      <ul className="list-disc pl-5 space-y-1 text-gray-800 text-[15px] leading-relaxed">
        {items.map((item, index) => (
          <li key={`${label}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

export default function ReadableSummary({
  summary,
  emptyText = "No summary available",
  showPrimaryLabel = false,
}) {
  const formatted = formatSummaryForDisplay(summary);

  if (formatted.isEmpty) {
    return (
      <div className="text-gray-800 text-[15px] leading-relaxed break-words">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {showPrimaryLabel ? (
        <SummaryField label="Call Summary" value={formatted.summaryText || emptyText} />
      ) : (
        <div className="text-gray-800 text-[15px] leading-relaxed break-words whitespace-pre-wrap">
          {formatted.summaryText || emptyText}
        </div>
      )}

      {formatted.isStructured ? (
        <div className="space-y-4">
          <SummaryField label="Intent" value={formatted.intent} />
          <SummaryField label="Sentiment" value={humanizeValue(formatted.sentiment)} />
          <SummaryField label="Outcome" value={humanizeValue(formatted.outcome)} />
          <SummaryField label="Outcome Detail" value={formatted.outcomeDetail} />
          <SummaryList label="Key Points" items={formatted.keyPoints} />
          <SummaryList label="Follow-up" items={formatted.followUpItems} />
          {formatted.hasFollowUpRequired ? (
            <SummaryField
              label="Follow-up Required"
              value={formatted.followUpRequired ? "Yes" : "No"}
            />
          ) : null}
          <SummaryField label="Follow-up Date" value={formatted.followUpDate} />
          <SummaryField label="Follow-up Notes" value={formatted.followUpNotes} />
          {formatted.hasEscalationNeeded ? (
            <SummaryField
              label="Escalation Needed"
              value={formatted.escalationNeeded ? "Yes" : "No"}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
